import { Helmet } from 'react-helmet';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import WhyDtp from './components/WhyDtp';
import { useNavigate } from "react-router-dom";
import { homeFeature_new } from './data/homeFeature_new';
import { testimonials } from "./data/testimonials";
import { whyDtpFeatures } from './data/whyDtpFeatures';

const TryFree = () => {

    const navigate = useNavigate();
    const mediaUrl = process.env.REACT_APP_PUBLIC_CDN_URL;

    
    const startSurvey = () => {
        navigate('/survey', {
            state: {
                data: null
            },
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }


    return (
        <>
            <Helmet>
                <title>Device Tracker App, Get Peace of Mind with Device Tracker Plus</title>
                <meta name="description" content="Accurate device tracking & real-time location sharing for families, friends & couples. Stay connected with the world's no.1 mobile device tracker app." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/devicetrackingapp" />
            </Helmet>
            <Hero showCheckout={startSurvey} mediaUrl={mediaUrl}/>
            <Features features={homeFeature_new} showCheckoutPopup={startSurvey} />
            <HowItWorks />
            <Testimonials testimonials={testimonials} showCheckoutPopup={startSurvey} />
            <WhyDtp reasons={whyDtpFeatures} showCheckoutPopup={startSurvey} />
        </>
    )
}

export default TryFree;